import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }


export default {
  __name: 'BookingCountdownText',
  props: {
	days: { type: Number, default: 0 },
	hours: { type: Number, default: 0 },
	minutes: { type: Number, default: 0 },
	seconds: { type: Number, default: 0 },
	textClass: { type: String, default: "text-info" },
},
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["countdown-time ms-1", __props.textClass])
  }, [
    (__props.days > 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.days) + "d ", 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (__props.hours > 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.hours) + "h ", 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (__props.minutes > 0 || __props.hours > 0 || __props.days > 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.minutes) + "m ", 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("span", null, _toDisplayString(__props.seconds) + "s", 1 /* TEXT */)
  ], 2 /* CLASS */))
}
}

}